// extracted by mini-css-extract-plugin
export default {"loader":"CreationInProgress_loader__Us3Yu","loaderImg":"CreationInProgress_loaderImg__aKFPb"};